// ─── Collage Element Renderer ─────────────────────────────────
// Routes element types to their components.

import React from 'react';
import ImageCard from './elements/ImageCard';
import TextNote from './elements/TextNote';
import TextBlock from './elements/TextBlock';
import TitleBlock from './elements/TitleBlock';
import ShapeElement from './elements/ShapeElement';
import OrnamentElement from './elements/OrnamentElement';
import VinylElement from './elements/VinylElement';
import SlideshowElement from './elements/SlideshowElement';
import RsvpButtonElement from './elements/RsvpButtonElement';

const ELEMENT_MAP = {
  'image_card': ImageCard,
  'text_note': TextNote,
  'text_block': TextBlock,
  'title_block': TitleBlock,
  'shape': ShapeElement,
  'ornament': OrnamentElement,
  'vinyl_player': VinylElement,
  'slideshow_element': SlideshowElement,
  'rsvp_button': RsvpButtonElement,
};

export default function CollageElementRenderer({ element, isMobile, theme, rsvpRef, skipPositioning, isEditing, onEditText }) {
  const Component = ELEMENT_MAP[element.type];
  if (!Component) return null;
  return <Component element={element} isMobile={isMobile} theme={theme} rsvpRef={rsvpRef} skipPositioning={skipPositioning} isEditing={isEditing} onEditText={onEditText} />;
}
